/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OutstandingPaymentsContainer_viewer$ref: FragmentReference;
export type OutstandingPaymentsContainer_viewer = {|
  +outstanding_payments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +amount_cents: number,
        +amount_currency: string,
        +payment_date: any,
        +invoice: ?{|
          +id: string,
          +title: ?string,
          +workspaces: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +event: ?{|
                  +title: ?string
                |}
              |}
            |}>
          |},
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +hasNextPage: boolean,
    |},
  |},
  +$refType: OutstandingPaymentsContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "OutstandingPaymentsContainer_viewer",
  "type": "User",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "outstanding_payments"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "outstanding_payments_after",
      "type": "ISO8601Type",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "outstanding_payments_before",
      "type": "ISO8601Type",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "outstanding_payments",
      "name": "__OutstandingPayments_outstanding_payments_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after_time",
          "variableName": "outstanding_payments_after",
          "type": "ISO8601Type"
        },
        {
          "kind": "Variable",
          "name": "before_time",
          "variableName": "outstanding_payments_before",
          "type": "ISO8601Type"
        }
      ],
      "concreteType": "OutstandingPaymentConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "OutstandingPaymentEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "OutstandingPayment",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount_cents",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount_currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "payment_date",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "invoice",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Invoice",
                  "plural": false,
                  "selections": [
                    v0,
                    v1,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "workspaces",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "WorkspaceConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "WorkspaceEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Workspace",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "event",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "Event",
                                  "plural": false,
                                  "selections": [
                                    v1
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd0720ef90fab38329d8d7251dac45675';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Financial/Payments/__generated__/OutstandingPaymentsContainer_viewer.graphql.js